import { ACCESS_FEATURES_ACTION, ACCESS_FEATURES_UPDATE_ACTION } from "../../actionType/accessFeatures";
import { DATA_UPLOAD_TOGGLE_ACTION } from "../../actionType/accessFeatures";

const intialState = {
    accessFeatureData: [],
    isaccessFeatureLoader: false,
    dataUploadToggledata: {},
    isSetDataUploadStatusLoader: false,
};

export const accessFeaturesReducer = (state = intialState, { type, payload }: any) => {
    switch (type) {
        case ACCESS_FEATURES_ACTION.ACCESS_FEATURES_REQUEST:
            return { ...state, accessFeatureData: payload, isaccessFeatureLoader: true };
        case ACCESS_FEATURES_ACTION.ACCESS_FEATURES_RESPONSE:
            return { ...state, accessFeatureData: payload, isaccessFeatureLoader: false };

        case ACCESS_FEATURES_ACTION.ACCESS_FEATURES_ERROR:

            return { ...state, accessFeatureData: payload, isaccessFeatureLoader: false };

        case DATA_UPLOAD_TOGGLE_ACTION.DATA_UPLOAD_TOGGLE_REQUEST:
            return { ...state, dataUploadToggledata: payload, isSetDataUploadStatusLoader: true };
        case DATA_UPLOAD_TOGGLE_ACTION.DATA_UPLOAD_TOGGLE_RESPONSE:
            return { ...state, dataUploadToggledata: payload, isSetDataUploadStatusLoader: false };

        case DATA_UPLOAD_TOGGLE_ACTION.DATA_UPLOAD_TOGGLE_ERROR:

            return { ...state, dataUploadToggledata: payload, isSetDataUploadStatusLoader: false };


        case ACCESS_FEATURES_UPDATE_ACTION.ACCESS_FEATURES_UPDATE_REQUEST:
            return { ...state, isaccessFeatureLoader: true };
        case ACCESS_FEATURES_UPDATE_ACTION.ACCESS_FEATURES_UPDATE_RESPONSE:
            return { ...state, isaccessFeatureLoader: false };

        case ACCESS_FEATURES_UPDATE_ACTION.ACCESS_FEATURES_UPDATE_ERROR:

            return { ...state, isaccessFeatureLoader: false };
        default:
            return state;
    }

}